import { useEffect, useMemo } from 'react'

import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import BadgeIsValid from '~/components/BadgeIsValid'
import Loading from '~/components/Loading'
import Panel from '~/components/Panel'
import { usePaymentTypes } from '~/modules/retailMedia/hooks/usePaymentTypes'
import { useRechargeForm } from '~/modules/retailMedia/pages/walltets/recharge/hooks/useRechargeForm'

import MultiMethodSection from './Multi'
import SingleMethodSection from './Single'

const MethodSection = () => {
  const { data: paymentTypes } = usePaymentTypes()

  const {
    handleChangePaymentMethod,
    paymentSectionIsValid,
    isPendingMarketplaceBalance,
    errorMarketplaceBalance
  } = useRechargeForm()

  const hasOnlyOnePaymentMethod = useMemo(
    () => paymentTypes.length === 1,
    [paymentTypes]
  )

  useEffect(() => {
    if (hasOnlyOnePaymentMethod) {
      handleChangePaymentMethod(paymentTypes?.[0]?.type as PaymentMethod)
    }
  }, [hasOnlyOnePaymentMethod, handleChangePaymentMethod, paymentTypes])

  return (
    <Panel
      title={t('rm:Payment')}
      description={hasOnlyOnePaymentMethod ? null : t('rm:payment.method')}
      iconLeft={<BadgeIsValid isValid={paymentSectionIsValid} />}
    >
      {isPendingMarketplaceBalance && (
        <Loading status={isPendingMarketplaceBalance}>
          {t('rm:marketplace.loading.balance')}
        </Loading>
      )}

      {errorMarketplaceBalance && (
        <Alert variant="critical" className="mb-2">
          {t('rm:marketplace.error.balance')}
        </Alert>
      )}

      {hasOnlyOnePaymentMethod ? (
        <SingleMethodSection paymentType={paymentTypes[0].type} />
      ) : (
        <MultiMethodSection />
      )}
    </Panel>
  )
}

export default MethodSection
